import { createSelector } from 'reselect'
import { getGroupIndex, getMediaIndex} from 'redux/navigation/selectors'

export const getTableOfContents = state => state.tableOfContents.table || []

export const isTableOfContentsAsideEnabled = createSelector(
    getTableOfContents,
    tableOfContents => tableOfContents.length > 0
)

export const isTableOfContentsItemSelected = createSelector(
    getTableOfContents,
    getMediaIndex,
    getGroupIndex,
    (state, index) => index,
    (tableOfContents, mediaIndex, groupIndex, index) => {

        if(
            tableOfContents[index] === undefined
            || tableOfContents[index].positions === null
        ){
            return false
        }

        const indexes = tableOfContents[index].positions

        return indexes.media === mediaIndex && indexes.group === groupIndex;
    }
)

export const getTableOfContentsCurrentIndex = createSelector(
    getTableOfContents,
    getMediaIndex,
    getGroupIndex,
    (tableOfContents, mediaIndex, groupIndex) => {
        let currentIndex = 0
        tableOfContents.forEach((item, index) => {
            if(item.positions === null)
            {
                return
            }

            const indexes = tableOfContents[index].positions
            if(indexes.group === groupIndex && indexes.media === mediaIndex)
            {
                currentIndex = index
            }
        })

        return currentIndex
    }
)

export const isTableOfContentsOpened = state => state.tableOfContents.isOpened === true
